// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"bc29d93f","453":"164fd95f"}[chunkId] + ".chunk.js";
};